export default __webpack_public_path__ + "static/media/about_me_inset.f46898fd.jpg";